<div class="radio__container radio-tiles"
     [ngClass]="{'predefined-value': predefinedStyleEnabled, 'radio__container--inline': fieldConfig.radioInline }">

  <div class="radio__text tooltip--reset-top">
    <span class="radio__text__label">{{ fieldConfig.caption | translate }}</span>
    <app-tooltip-icon class="reset-position"
                      *ngIf="tooltipIconVisible"
                      [outlined]="fieldConfig.tooltipIconOutlined"
                      [description]="fieldConfig.description"></app-tooltip-icon>
    <app-information-icon class="information-icon" class="reset-position no-absolute"
                          *ngIf="informationIconVisible"
                          [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                          [description]="fieldConfig.description | translate">
    </app-information-icon>
  </div>

  <div class="radio__element" [class.radio-error]="errorsMap.get(fieldConfig.fieldKey)">
    <mat-radio-group
            matRadioGroup
            id="{{fieldConfig.fieldKey}}"
            (change)="onChange($event)"
            (click)="onClick($event)"
            [formControl]="control">
        <mat-radio-button *ngFor="let config of fieldConfig.radioConfig"
                          [ngClass]="config.outsideLabel ? 'radio-tile radio-tile__outside' : 'radio-tile'"
                          [class.radio-tile--highlighted]="config.highlighted"
                          #radioTile
                          [disabled]="config.disabled"
                          id="{{fieldConfig.fieldKey + '-' + config.value}}"
                          [value]="config.value">
          <div *ngIf="config.highlighted" class="radio-tile__recommendation">
            <div class="radio-tile__recommendation__label">{{ 'OFFER_SECTION.SHARED.recommended' | translate }}</div>
            <img class="radio-tile__recommendation__image"
                 [src]="highlightedImageSrc">
          </div>
          <div [class]="radioTile.checked ? 'radio-tile__label radio-tile__label--checked': 'radio-tile__label'">
            {{(config.label) | translate}}
          </div>
          <div *ngIf="hasPrice(config)" class="radio-tile__price">
            {{ config.price | commaReplacement | separator }}&nbsp;{{ 'OFFER_SECTION.SHARED.currencyShortcut' | translate }}
          </div>
<!--          <span *ngIf="radioTile.checked" class="material-icons radio-tile__icon">check</span>-->
        </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)" class="radio-error">{{ (context + '.' +
            fieldConfig.fieldKey + '.' +
            errorsMap.get(fieldConfig.fieldKey))|translate}}
    </mat-error>
  </div>
</div>
